const SOCKET_IO_PORT = 3001

module.exports.BACKEND_URL = process.env.REACT_APP_API_URL || 'backend'

const { protocol, hostname } = window.location
// change based on local or dev/prod
// module.exports.SOCKET_URL = `${protocol}//${hostname}:${SOCKET_IO_PORT}`
module.exports.SOCKET_URL = `${protocol}//${hostname}`



// WEBPACK FOOTER //
// ./src/config/environment.js